/* eslint-disable no-unused-vars */
import React, {PureComponent} from 'react';
import { Button, Transition, Icon } from 'semantic-ui-react'

export default class ControlPanel extends PureComponent {

  state = { visible: true }

  toggleVisibility = () => this.setState({ visible: !this.state.visible })

  _shareOnTwitter = () => {
    window.open('https://www.bspaint.net', '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=600,width=600');
  }

  render() {

    const { showControlPanel, zoomOut } = this.props;

    return (
      <div>

      <div style={{position: 'absolute', bottom: 50, right: 50, maxWidth: 200, maxHeight: '80%',overflow: 'auto'}}>
      <Transition visible={showControlPanel} animation='scale' duration={500}>
        <Button color='google plus' onClick={zoomOut} ><Icon name='globe' /> Where am I?</Button>
        </Transition>
      </div>

      <div style={{position: 'absolute', bottom: 50, left: 50, maxWidth: 200, maxHeight: '80%',overflow: 'auto'}}>
      <Transition visible={showControlPanel} animation='scale' duration={500}>
        <Button color='twitter' onClick={this._shareOnTwitter} ><Icon name='twitter' /> Share</Button>
        </Transition>
      </div>

      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/Hello/control-panel.js